import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    direction: "rtl",
    palette: {
        primary: {
            main: "#2b5999",
        },
    },
});

export default theme;
